var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex flex-col items-center select-none",staticStyle:{"width":"60px"}},[_c('img',{attrs:{"src":_vm.props.icon,"width":"37"}}),_c('span',{staticClass:"sm:hidden md:block text-sm mt-1"},[_vm._v(_vm._s(_vm.props.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }